<template>
  <div>
    <map-base ref="mapCom" :map="map" />
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "press",
  props: ["map"],
  components: {},
  data() {
    return {
      layerId: "",
    };
  },
  watch: {},
  created() {
    // console.log("进入created方法");
  },
  mounted() {},
  updated() {
    // console.log("进入updated方法");
  },
  methods: {
    /**
     * 分辨率监听事件
     */
    changeResolution() {},
    /**
    鼠标滑动事件
     */
    touchOnly() {},
    /**
     * 地图单击事件
     * @param {*} evt
     */
    doIdentify(type, data) {
      switch (type) {
        case "mapClick": {
          break;
        }
        case "featureClick": {
          let feature = data.feature;
          switch (data.layerId) {
            case this.layerId: {
              let showData = {
                名称: feature.get("name"),
                湿度: feature.get("RN") + feature.get("danwei"),
                时间: feature.get("LASTUPDATE").replace("T", " "),
              };
              let title = "";
              this.$refs.mapCom.initInfoWinContainer(
                feature.getGeometry().flatCoordinates,
                [showData],
                title,
                [],
                () => {}
              );
              break;
            }
          }
          break;
        }
      }
    },
    async addData(param) {
      this.layerId = param.layerId;
      let data = param.data;
      if (!param.isRefresh) {
        this.removeLayer();
        const layer = this.addLayer();
        let features = [];
        let featuresName = [];
        data.map((v) => {
          v.longitude = Number(v.lon);
          v.latitude = Number(v.lat);
          v.name = v.JCD;
          v.danwei = param.parm.danWei;
          if (this.$isValue(v.longitude) && this.$isValue(v.latitude)) {
            let featureName = new this.mapApi.Feature({
              geometry: new this.mapApi.Point([v.longitude, v.latitude]),
            });
            let textColor = " rgb(255, 255, 255)";
            let htmlName =
              '<svg width="200" height="20" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
              '<rect x="' +
              0 +
              '" y="' +
              0 +
              '" width="' +
              200 +
              '" height="' +
              20 +
              '" style="fill:rgb(0, 129, 255);stroke-width:1;stroke:rgb(0, 129, 255);"/>' +
              '<text fill="' +
              textColor +
              '" x="' +
              100 +
              '" y="' +
              10 +
              '" style="dominant-baseline:middle;text-anchor:middle;font-size:15">' +
              v.name +
              "</text>" +
              "</svg>";
            featureName.setStyle(
              new this.mapApi.Style({
                image: new this.mapApi.Icon({
                  src:
                    "data:image/svg+xml;utf8," + encodeURIComponent(htmlName),
                  scale: 1,
                  displacement: [0, 22],
                }),
              })
            );
            featureName.setId(Math.random());
            featuresName.push(featureName);

            let feature = new this.mapApi.Feature({
              geometry: new this.mapApi.Point([v.longitude, v.latitude]),
            });
            feature.setProperties(v);
            let dataColor = this.getDataColor({
              isAlarm: feature.get("isalarm"),
              isClock: feature.get("StationStatus"),
            });
            let html = this.getSvg(
              Object.assign(
                {
                  text: feature.get("RN"),
                  isAlarm: feature.get("isalarm"),
                  isClock: feature.get("StationStatus"),
                },
                dataColor
              )
            );
            feature.setStyle(
              new this.mapApi.Style({
                image: new this.mapApi.Icon({
                  src: "data:image/svg+xml;utf8," + html,
                  scale: 1,
                }),
              })
            );
            features.push(feature);
          }
        });
        layer.getSource().addFeatures(features);

        this.moveendEvt = this.map.on("moveend", () => {
          if (this.map.getView().getZoom() >= param.zoom) {
            if (!layer.getSource().getFeatureById(featuresName[0].getId()))
              featuresName.map((v) => {
                layer.getSource().addFeature(v);
              });
          } else {
            featuresName.map((v) => {
              layer.getSource().removeFeature(v);
            });
          }
        });
      } else {
        let layer = this.$refs.mapCom.getLayer(this.layerId, 1);
        if (layer) {
          let features = this.$refs.mapCom
            .getLayer(this.layerId, 1)
            .getSource()
            .getFeatures();
          data.map((v) => {
            features.map((feature) => {
              if (feature.get("name") === v.JCD) {
                feature.setProperties(v);
                let dataColor = this.getDataColor({
                  isAlarm: feature.get("isalarm"),
                  isClock: feature.get("StationStatus"),
                });
                let html = this.getSvg(
                  Object.assign(
                    {
                      text: feature.get("RN"),
                      isAlarm: feature.get("isalarm"),
                      isClock: feature.get("StationStatus"),
                    },
                    dataColor
                  )
                );
                feature.getStyle().getImage().getImage().src =
                  "data:image/svg+xml;utf8," + html;
              }
            });
          });
        }
      }
    },
    getDataColor(param) {
      let textBgColor = "rgb(0,160,20)";
      let opacity = 1;
      if (param.isClock == 1) {
        if (param.isAlarm == "0") {
          // 绿色
          textBgColor = "rgb(0,160,20)";
          opacity = 1;
        } else if (param.isAlarm == "1") {
          //橘色
          textBgColor = "rgb(238,121,48)";
          opacity = 1;
        } else if (param.isAlarm == "2") {
          // 绿色
          textBgColor = "rgb(0,160,20)";
          opacity = 1;
        } else if (param.isAlarm == "3") {
          //蓝色
          textBgColor = "rgb(38,108,246)";
          opacity = 1;
        } else if (param.isAlarm == "4") {
          //浅橘色
          textBgColor = "rgb(247,199,68)";
          opacity = 1;
        } else if (param.isAlarm == "5") {
          // 橘色
          textBgColor = "rgb(247,199,68)";
          opacity = 1;
        } else if (param.isAlarm == "6") {
          //浅红色
          textBgColor = "rgb(200,56,66)";
          opacity = 1;
        } else if (param.isAlarm == "7") {
          //浅红色
          textBgColor = "rgb(200,56,66)";
          opacity = 1;
        } else {
          //绿色
          textBgColor = "rgb(0,160,20)";
          opacity = 1;
        }
      } else {
        //灰色
        textBgColor = "rgb(191, 175, 165)";
        opacity = 0.5;
      }
      return {
        textBgColor: textBgColor,
        opacity: opacity,
      };
    },
    getSvg(param) {
      let width = 60;
      let height = 20;
      let padding = 2.5;
      let x = 0; // 起始x
      let y = 0; // 起始y
      let angle0 = 45; // 图形angle
      let x0 = 40; // 图形x
      let y0 = 0; // 图形y
      let width0 = 20; // 图形width
      let height0 = 20; // 图形height

      let x1 = 0; // 数值x
      let y1 = 0; // 数值y
      let width1 = 40; // 数值width
      let height1 = 20; // 数值height
      let value1 = param.text; // 数值

      let textColor = "rgb(255,255,255)";
      let textBgColor = param.textBgColor;
      let opacity = param.opacity;
      var svg = this.$insertElement("svg", null);
      var path = this.$insertElement("path", null, svg);
      path.setAttribute(
        "d",
        "M" +
          (x0 + width0 / 2) +
          " " +
          (y0 + padding) +
          " " +
          "L" +
          (x0 + padding) +
          " " +
          (y0 + height0 / 2) +
          " " +
          "ZM" +
          (x0 + width0 / 2) +
          " " +
          (y0 + padding) +
          " " +
          "L" +
          (x0 + width0 - padding) +
          " " +
          (y0 + height0 / 2) +
          " " +
          "ZM" +
          (x0 + width0 / 2) +
          " " +
          (y0 + padding) +
          " " +
          "L" +
          (x0 + width0 / 2) +
          " " +
          (y0 + height0 - padding) +
          " " +
          "Z"
      );
      path.setAttribute("fill", "white");
      path.setAttribute("stroke", textColor);
      path.setAttribute("stroke-width", padding);
      path.setAttribute(
        "transform",
        "translate(" +
          (x0 + width0 / 2) +
          "," +
          (y0 + height0 / 2) +
          ") scale(1) rotate(" +
          angle0 +
          ") translate(" +
          -(x0 + width0 / 2) +
          "," +
          -(y0 + height0 / 2) +
          ")"
      );
      let par =
        '<svg width="' +
        width +
        '" height="' +
        height +
        '" version="1.1" xmlns="http://www.w3.org/2000/svg">' +
        '<rect x="' +
        x1 +
        '" y="' +
        y1 +
        '" width="' +
        width1 +
        '" height="' +
        height1 +
        '" style="opacity:' +
        opacity +
        ";fill:" +
        textBgColor +
        ";stroke-width:1;stroke:" +
        textBgColor +
        ';"/>' +
        '<text fill="' +
        textColor +
        '" x="' +
        (x1 + width1 / 2) +
        '" y="' +
        (y1 + height1 / 2) +
        '" style="dominant-baseline:middle;text-anchor:middle;font-size:15">' +
        value1 +
        "</text>" +
        "</svg>";
      return par;
    },
    addLayer() {
      let layer = this.$refs.mapCom.createLayer(this.layerId);
      this.map.addLayer(layer);
      return layer;
    },
    removeLayer() {
      if (this.$refs.mapCom.getLayer(this.layerId, 1))
        this.$refs.mapCom.removeLayer(this.layerId, 1);
      this.$refs.mapCom.closeInfoWin();
      this.mapApi.unByKey(this.moveendEvt);
    },
  },
};
</script>
<style>
.aaa {
  display: none;
}
</style>
